export const inlineFormStickySxProps = {
  header: {
    paddingTop: 0,
  },
  notification: {
    paddingTop: '8px',
    paddingLeft: 0,
    paddingRight: 0,
  },
};
